import { Component, Input, OnInit } from '@angular/core';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { FunnelService } from 'src/app/infraestructure/drive-adapter/funnel-service/funnel.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer-default',
  templateUrl: './footer-default.component.html',
  styleUrls: ['./footer-default.component.scss']
})
export class FooterDefaultComponent implements OnInit {
  @Input() showIconInc5000!: boolean;
  @Input() IsOrganicFunnel!:boolean;
  @Input() currentYear!: number;
  @Input() brandResources!: IBrandResources;
  @Input() IsCustomDefault!:boolean;
  @Input() IsDeclinePage!:boolean;
  public environment = environment;
 
  constructor(public funnelService: FunnelService) { }

  ngOnInit(): void {
    
  }

}
